// extracted by mini-css-extract-plugin
export default {"cube":"Styles_cube__v1aDw","cubeWrapper":"Styles_cubeWrapper__5yvbW","canvas":"Styles_canvas__Oc64H","content":"Styles_content__RjRGF"};